// Footer.js
import React, {Component} from 'react';

export default class Footer extends Component {
    render(){
        return (
                <div>
            <footer className="mt-auto footer-dark text-light bg-dark">
  <div className="container">
    <div className="region region-footer">
      <div id="block-copyroght" className="block block-block-content block-block-contentb0ede407-a133-4d30-86ba-c261452b77e6">
        <div className="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item">
          <p>© 2022 IntelliSaving. All Rights Reserved</p>
        </div>
      </div>
      <nav role="navigation" aria-labelledby="block-intellisaving-footer-menu" id="block-intellisaving-footer" className="block block-menu navigation menu--footer">
        <h5 className="visually-hidden" id="block-intellisaving-footer-menu">Footer</h5>
        <ul className="nav navbar-nav">
          <li className="nav-item">
            <a href="/" className="nav-link is-active" data-drupal-link-system-path="<front>">Home </a>
          </li>
          <li className="nav-item">
            <a href="/careers" className="nav-link" data-drupal-link-system-path="node/1">Careers</a>
          </li>
          <li className="nav-item">
            <a href="/contact" className="nav-link" data-drupal-link-system-path="contact">Contact</a>
          </li>
          <li className="nav-item">
            <a href="/privacy-policy" className="nav-link" data-drupal-link-system-path="node/6">Privacy Policy</a>
          </li>
          <li className="nav-item">
            <a href="/terms" className="nav-link" data-drupal-link-system-path="node/5">Terms of Service</a>
          </li>
        </ul>
      </nav>
      <div id="block-companyinfo" className="block block-block-content block-block-content5346e2eb-0885-4ed4-aca0-08a59c8c3dd8">
        <div className="clearfix text-formatted field field--name-body field--type-text-with-summary field--label-hidden field__item">
          <div className="text-center text-white-50">
            <small>IntelliSaving is authorised and regulated by the Financial Conduct Authority (FRN: 942808). <br/> IntelliSaving is a trading name of IntelliSaving Limited, a company registered in England and Wales (Number: 12827813). </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

   </div>
        )
    }
}